import { AccordionItemProps, AccordionList, Typography } from '@sonnen/web-ui';
import { memo, useMemo } from 'react';
import { useAppContext } from '../../../AppContext/AppContext';
import { FillInfoCard } from '../../../components/FillInfoCard/FillInfoCard';
import { SideCard } from '../../../components/SideCard/SideCard';
import { SideCardButton } from '../../../components/SideCardButton/SideCardButton';
import SummaryCard from '../../../components/SummaryCard/SummaryCard';
import { AppRoute } from '../../../constants';
import { Currency } from '../../../graphql/generated';
import { useCurrentRoute } from '../../../hooks/useCurrentRoute';
import { useTranslation } from '../../../i18n/i18n';
import { OrderFlow } from '../../../types';
import { formatCurrency } from '../../../utils/formatting';

const ZERO_PRICE = {
  value: '0',
  currency: Currency.Eur,
};

export const SelfConsumptionOfferCard = () => {
  const { userProcessing } = useAppContext();
  const { t } = useTranslation();
  const currentRoute = useCurrentRoute();

  const listEntries: AccordionItemProps[] = useMemo(() => {
    return [
      {
        label: t('selfConsumptionPlus.accordion.priceLabel'),
        value: `${formatCurrency(ZERO_PRICE, 'euro')}/${t('offer.month')}`,
        alwaysOpen: true,
      },
      {
        label: t('minimumContractDuration'),
        value: t('selfConsumptionPlus.accordion.minimumContractDurationValue'),
        alwaysOpen: true,
      },
      {
        label: t('selfConsumptionPlus.accordion.terminationPeriodLabel'),
        value: t('selfConsumptionPlus.accordion.terminationPeriodValue'),
        alwaysOpen: true,
      },
    ];
  }, [t]);

  return (
    <SideCard dataTestId={`${OrderFlow.selfConsumptionPlus}-offer-card`}>
      <Typography.H2>{t('selfConsumptionPlus.detailCard.title')}</Typography.H2>

      {currentRoute !== AppRoute.SELF_CONSUMPTION_PLUS && (
        <FillInfoCard>
          <SummaryCard
            value={{
              currency: Currency.Eur,
              value: '0.00',
            }}
          />
        </FillInfoCard>
      )}

      {currentRoute !== AppRoute.DATA_ENTRY && (
        <AccordionList list={listEntries} dataTestId="self-consumption-plus" />
      )}
      <SideCardButton loading={userProcessing} />
    </SideCard>
  );
};

export default memo(SelfConsumptionOfferCard);
